import React from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { getTranslate } from "react-localize-redux";
import { actions } from "react-redux-form";
import moment from "moment";
import ReactTooltip from "react-tooltip";
import ReactJson from "react-json-view";
import axios from "axios";
import FileSaver from "file-saver";
import {
  Pagination,
  PaginationItem,
  PaginationLink,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Button,
  Alert,
  ListGroup,
  ListGroupItem,
  Label,
  Input,
  FormGroup,
  Spinner,
} from "reactstrap";

import { SearchPanel } from "../../AppLayout/SearchPanel/SearchPanel";
import { EditConfigReport } from "../configuredReports/editConfigReport";
import {
  reportActions,
  loaderMaskActions,
  configActions,
} from "../../../../redux/actions";
import { getReportData } from "../../../../utils";
import "./ExecReports.css";

const qs = require("qs");

class ExecReports extends React.Component {
  state = {
    fullEventModal: false,
    eventJsonObj: {},
    msg: {},
    selectedReport: "",
    editReportIsActive: false,
    editReportIsInternalUse: false,
    loadingFile: false,
  };

  handleOpenFullEventClick(e, dataObject) {
    if (dataObject) {
      this.setState({
        eventJsonObj: dataObject,
        fullEventModal: true,
      });
    }
  }

  toggleFullEventModal = () => {
    this.setState({
      fullEventModal: !this.state.fullEventModal,
    });
  };

  handlePageClick = (event) => {
    event.preventDefault();
    const {
      dispatch,
      reports,
      execReportSearch,
      isExternalUser,
      externalCustomerId,
    } = this.props;
    var _pageNum = Number(event.target.id);
    if (_pageNum > 0) {
      if (reports.execReportsFromURIQuery) {
        dispatch(reportActions.setExecReportsParams("PageNumber", _pageNum));
        dispatch(
          reportActions.getExecReportsFromURIQuery({
            ...reports.execReportsParams,
            PageNumber: _pageNum,
          })
        );
      } else {
        dispatch(actions.change("execReportSearch.PageNumber", _pageNum));
        dispatch(
          reportActions.getExecutedReports(
            getSearchingData(
              { ...execReportSearch, PageNumber: _pageNum },
              isExternalUser,
              externalCustomerId
            )
          )
        );
      }
    }
  };

  handlePageSizeChange = (e) => {
    const {
      dispatch,
      reports,
      execReportSearch,
      isExternalUser,
      externalCustomerId,
    } = this.props;
    var _sizeNum = Number(e.target.value);
    if (_sizeNum > 0) {
      if (reports.execReportsFromURIQuery) {
        dispatch(reportActions.setExecReportsParams("Size", _sizeNum));
        dispatch(
          reportActions.getExecReportsFromURIQuery({
            ...reports.execReportsParams,
            Size: _sizeNum,
          })
        );
      } else {
        dispatch(actions.change("execReportSearch.Size", _sizeNum));
        dispatch(
          reportActions.getExecutedReports(
            getSearchingData(
              { ...execReportSearch, Size: _sizeNum },
              isExternalUser,
              externalCustomerId
            )
          )
        );
      }
    }
  };

  handleFirstClick = (event) => {
    event.preventDefault();
    const {
      dispatch,
      reports,
      execReportSearch,
      isExternalUser,
      externalCustomerId,
    } = this.props;
    if (reports.execReportsFromURIQuery) {
      dispatch(reportActions.setExecReportsParams("PageNumber", 1));
      dispatch(
        reportActions.getExecReportsFromURIQuery({
          ...reports.execReportsParams,
          PageNumber: 1,
        })
      );
    } else {
      dispatch(actions.change("execReportSearch.PageNumber", 1));
      dispatch(
        reportActions.getExecutedReports(
          getSearchingData(
            { ...execReportSearch, PageNumber: 1 },
            isExternalUser,
            externalCustomerId
          )
        )
      );
    }
  };

  handleRowClick = (e, report, index) => {
    var sel = getSelection().toString();
    if (!sel) {
      let _el = e.target;
      let _action = _el.getAttribute("data-action");
      const { dispatch } = this.props;
      dispatch(reportActions.setActiveRow("executedReports", index));
      switch (_action) {
        case "restart-pipeline":
          break;
        default:
          dispatch(
            reportActions.loadPipelinesByPipelineId(
              report.pipelineInstanceId,
              index
            )
          );
          dispatch(reportActions.expandRow("executedReports", index));
          break;
      }
    }
  };

  handleEditConfigReportClick = (e, execReport) => {
    e.stopPropagation();
    var me = this;
    const { config, dispatch } = this.props;
    axios
      .get("Reporting/Definitions/GetById", {
        params: { definitionId: execReport.reportDefinitionId },
      })
      .then((response) => {
        if (response.data.Errors && response.data.Errors.length) {
          me.setState({
            msg: {
              header: "Editing configured report",
              message: (
                <Alert style={{ width: "650px" }} color="danger">
                  Unexpected server error.
                </Alert>
              ),
            },
          });
        } else {
          var report = response.data.Data;
          var _repDescJson = config.reportsDescriptions || [];
          var repDescObjRef =
            _repDescJson.find((obj) => {
              return (
                obj.reporttemplatename === report.reportPipelineDefinitionId
              );
            }) || {};

          let selectedReport = JSON.parse(JSON.stringify(report));
          delete selectedReport.isActive;
          me.setState({
            selectedReport: selectedReport,
            editReportIsActive: report.active,
            editReportIsInternalUse: !!report.internalUse,
          });
          dispatch(
            configActions.toggleEditConfigReportModal(
              true,
              report,
              repDescObjRef
            )
          );
        }
      });
  };

  handleFormSave = (data, selectedReportType, reportForEdit, resetLoader) => {
    let reportData = getReportData(data, selectedReportType, {
      ...reportForEdit,
      active: this.state.editReportIsActive,
      internalUse: this.state.editReportIsInternalUse,
    });
    if (
      reportData.validationErrorMsgs &&
      reportData.validationErrorMsgs.length
    ) {
      if (resetLoader) resetLoader();
      this.setState({
        resetLoader: null,
        msg: {
          header: "Validation Error",
          message: (
            <ListGroup>
              {reportData.validationErrorMsgs.map((item, index) => (
                <ListGroupItem
                  key={index}
                  color="danger"
                  dangerouslySetInnerHTML={{
                    __html: item,
                  }}
                />
              ))}
            </ListGroup>
          ),
        },
      });
    } else if (reportData.schedulesConfirmRequired) {
      this.setState({
        pastNextLaunchConfirmModal: true,
        reportDataToBeSaved: reportData.data,
        resetLoader,
      });
    } else {
      this.saveReport(reportData.data, resetLoader);
    }
  };

  saveReport = (params, resetLoader) => {
    let updateDefinition = false;
    let updateSchedule = false;
    const originalDefinitionParams = Object.assign(
      {},
      this.state.selectedReport
    );
    delete originalDefinitionParams["schedules"];

    const definitionParams = Object.assign({}, params);
    delete definitionParams["schedules"];

    updateDefinition =
      JSON.stringify(originalDefinitionParams) !==
      JSON.stringify(definitionParams);

    // call update schudules if triggerType === "recurringreport"
    let schedulesParams;
    if (
      params.triggerType === "recurringreport" &&
      params.schedules &&
      params.schedules[0]
    ) {
      const originalSchedulesParams = Object.assign(
        {},
        this.state.selectedReport.schedules[0],
        {
          state: this.state.selectedReport.active ? "Pending" : "Canceled",
        }
      );

      schedulesParams = Object.assign({}, params.schedules[0], {
        state: params.active ? "Pending" : "Canceled",
      });

      updateSchedule =
        JSON.stringify(originalSchedulesParams) !==
        JSON.stringify(schedulesParams);
    }

    if (updateDefinition) {
      this.updateDefinition(
        definitionParams,
        updateSchedule,
        schedulesParams,
        resetLoader
      );
    } else if (updateSchedule) {
      this.updateSchedule(schedulesParams, resetLoader);
    } else {
      if (resetLoader) resetLoader();
      this.setState({
        resetLoader: null,
        msg: {
          header: "Report Update",
          message: <Alert color="danger">Nothing to update</Alert>,
        },
      });
    }

    if (updateDefinition || updateSchedule) {
      this.setState({
        resetLoader: null,
        selectedReport: JSON.parse(JSON.stringify(params)),
      });
    }
  };

  updateDefinition = (
    definitionParams,
    updateSchedule,
    schedulesParams,
    resetLoader
  ) => {
    axios
      .put("Reporting/Definitions/Update", definitionParams)
      .then((response) => {
        if (response.data.Errors && response.data.Errors.length) {
          if (resetLoader) resetLoader();
          this.setState({
            resetLoader: null,
            msg: {
              header: "Server Error",
              message: (
                <Alert color="danger">
                  <p>Server failed with the following errors:</p>
                  {response.data.Errors.join("<br />")}
                </Alert>
              ),
            },
          });
        } else {
          if (
            response.data.ValidationErrors &&
            response.data.ValidationErrors.length
          ) {
            if (resetLoader) resetLoader();
            this.setState({
              resetLoader: null,
              msg: {
                header: "Validation Error",
                message: (
                  <Alert color="danger">
                    <p>The following fields are missed:</p>
                    {response.data.ValidationErrors.join("<br />")}
                  </Alert>
                ),
              },
            });
          } else if (updateSchedule) {
            this.updateSchedule(schedulesParams, resetLoader);
          } else {
            // reload and close window
            this.props.dispatch(
              configActions.toggleEditConfigReportModal(false)
            );
            if (resetLoader) resetLoader();
            this.setState({
              resetLoader: null,
              msg: {
                header: "Report Update",
                message: (
                  <Alert color="success">Report updated successfully</Alert>
                ),
              },
            });
          }
        }
      });
  };

  updateSchedule = (schedulesParams, resetLoader) => {
    axios
      .put("Reporting/Schedules/Update", { Data: schedulesParams })
      .then((response) => {
        if (response.data.Errors && response.data.Errors.length) {
          if (resetLoader) resetLoader();
          this.setState({
            resetLoader: null,
            msg: {
              header: "Server Error",
              message: (
                <Alert color="danger">
                  <p>Server failed with the following errors:</p>
                  {response.data.Errors.join("<br />")}
                </Alert>
              ),
            },
          });
        } else {
          // reload and close window
          this.props.dispatch(configActions.toggleEditConfigReportModal(false));
          if (resetLoader) resetLoader();
          this.setState({
            resetLoader: null,
            msg: {
              header: "Report Update",
              message: (
                <Alert color="success">Report updated successfully</Alert>
              ),
            },
          });
        }
      });
  };

  handleActiveChange = () => {
    this.setState({
      editReportIsActive: !this.state.editReportIsActive,
    });
  };

  handleInternalUseChange = () => {
    this.setState({
      editReportIsInternalUse: !this.state.editReportIsInternalUse,
    });
  };

  togglePastNextLaunchConfirmModal = () => {
    if (this.state.resetLoader) this.state.resetLoader();
    this.setState({
      pastNextLaunchConfirmModal: !this.state.pastNextLaunchConfirmModal,
      resetLoader: null,
    });
  };
  handleYesConfirmNextLaunchDialog = () => {
    this.saveReport(this.state.reportDataToBeSaved, this.state.resetLoader);
    this.setState({
      pastNextLaunchConfirmModal: false,
      reportDataToBeSaved: null,
      resetLoader: null,
    });
  };
  handleNoConfirmNextLaunchDialog = () => {
    if (this.state.resetLoader) this.state.resetLoader();
    this.setState({
      pastNextLaunchConfirmModal: false,
      reportDataToBeSaved: null,
      resetLoader: null,
    });
  };

  isFileSelected = (pipelineInstanceId) => {
    return this.props.reports.selectedExecReports.includes(pipelineInstanceId);
  };

  isAllSelected = () => {
    const {
      reports: { executedReports, selectedExecReports },
    } = this.props;
    return (
      selectedExecReports &&
      executedReports &&
      selectedExecReports.length === executedReports.length
    );
  };
  toggleMultiSelectAll = () => {
    const { defaultSize, dispatch } = this.props;
    dispatch(reportActions.toggleSelectAll(defaultSize || 20));
  };

  toggleRowMultiSelect = (e, report, index) => {
    this.props.dispatch(
      reportActions.setExecReportSelection(report.pipelineInstanceId)
    );
  };

  generateReportGrid = () => {
    const {
      config,
      translate,
      isExternalUser,
      reports: { executedReports, execReportsPipelines, configuredReports },
    } = this.props;
    if (configuredReports && configuredReports.length === 0) {
      return (
        <div className="empty-text">
          <p>{translate("NoConfiguredReportMsg")}</p>
        </div>
      );
    }
    if (executedReports && executedReports.length === 0) {
      return (
        <div className="empty-text">
          <p>{translate("No reports match the specified filter")}</p>
        </div>
      );
    }
    var table_html = [];
    var me = this;
    const getParamValueFromPath = (path, index) => {
      if (
        execReportsPipelines &&
        execReportsPipelines[index] &&
        execReportsPipelines[index][0]
      ) {
        if (
          path &&
          path.includes &&
          (path.includes(".") || path.includes("["))
        ) {
          try {
            return (
              execReportsPipelines[index][0].components &&
              execReportsPipelines[index][0].components.length &&
              execReportsPipelines[index][0].components[0].params &&
              execReportsPipelines[index][0].components[0].params.data &&
              execReportsPipelines[index][0].components[0].params.data
                .scriptparams &&
              execReportsPipelines[index][0].components[0].params.data
                .scriptparams.inputData &&
              // eslint-disable-next-line no-eval
              eval(
                "_execReportsPipelines[index][0].components[0].params.data.scriptparams.inputData." +
                  path
              )
            );
          } catch (error) {
            return "";
          }
        }
        return (
          execReportsPipelines[index][0].components &&
          execReportsPipelines[index][0].components.length &&
          execReportsPipelines[index][0].components[0].params &&
          execReportsPipelines[index][0].components[0].params.data &&
          execReportsPipelines[index][0].components[0].params.data
            .scriptparams &&
          execReportsPipelines[index][0].components[0].params.data.scriptparams
            .inputData &&
          execReportsPipelines[index][0].components[0].params.data.scriptparams
            .inputData[path]
        );
      }
      return "";
    };

    const paramsList = (parameters, index) => {
      return (parameters || []).map((item, indx) => {
        return (
          <tr key={indx}>
            <td className="text-center">{item.paramDisplayName}</td>
            <td className="text-center" style={{ width: "60%" }}>
              <div className="ellipsis-long-string">
                {getParamValueFromPath(item.paramValuePath, index)}
              </div>
            </td>
          </tr>
        );
      });
    };

    const handleDownloadableFile = (fullPath, pipelineId, fileName, customerId = null) => {
      var params = {
        PipelineId: pipelineId,
        FileLocation: fullPath,
        ...(customerId ? { customerId }: {})
      };
      this.setState({
        loadingFile: true,
      });
      axios
        .get("Reporting/Pipelines/DownloadFileDirectly", {
          params: params,
          responseType: "blob",
        })
        .then((response) => {
          var data = new Blob([response.data]);
          FileSaver.saveAs(data, fileName);
          this.setState({
            loadingFile: false,
          });
        });
    };

    const getFileNameFromPath = (fullPath, pipelineId, customerId) => {
      var fileName = (fullPath || "").replace(/^.*[\\\/]/, "");
      return (
        <button
          className="default-button-link"
          onClick={(e) => {
            handleDownloadableFile(fullPath, pipelineId, fileName, customerId);
          }}
        >
          {fileName}
        </button>
      );
    };

    const getAdditionalInfo = (type, additionalInfo, pipelineId, customerId) => {
      if (type === "exec") {
        return (
          <div>
            <div>
              <strong>{translate("Documents included")}: </strong>
              <span>{additionalInfo.docCount}</span>
            </div>
            <div>
              <strong>{translate("Generated files")}: </strong>
              <div>
                {additionalInfo.generatedFiles &&
                  additionalInfo.generatedFiles.length &&
                  additionalInfo.generatedFiles.map((path, key) => {
                    return (
                      <span key={key}>
                        {path && getFileNameFromPath(path, pipelineId, customerId)}
                        <br />
                      </span>
                    );
                  })}
              </div>
            </div>
            {!isExternalUser && additionalInfo && additionalInfo.logFile && (
              <div>
                <strong>{translate("Logfile")}: </strong>
                <span>
                  {getFileNameFromPath(additionalInfo.logFile, pipelineId)}
                </span>
              </div>
            )}
          </div>
        );
      }
    };

    const getSmtpTransport = (transportItems) => {
      return transportItems
        .filter((item) => item.type === "Smtp")
        .map((item, index) => {
          return [
            <td
              key={"header-" + index}
              className="additional-info-header"
              style={{ padding: "0" }}
            >
              <div>
                <span>{translate("Email")}</span>
              </div>
            </td>,
            <td key={index} className="additional-info-content">
              <div className="transport-content">
                <div>
                  <div>
                    <strong>{translate("from")}: </strong>
                    <span>
                      {item.from &&
                        item.from.split(";").map((item, key) => {
                          return (
                            <span key={key}>
                              {item}
                              <br />
                            </span>
                          );
                        })}
                    </span>
                  </div>
                  {item.To && (
                    <div>
                      <strong>{translate("to")}: </strong>
                      <span>
                        {item.To &&
                          item.To.split(";").map((item, key) => {
                            return (
                              <span key={key}>
                                {item}
                                <br />
                              </span>
                            );
                          })}
                      </span>
                    </div>
                  )}
                  {item.cc && (
                    <div>
                      <strong>cc: </strong>
                      <span>
                        {item.cc &&
                          item.cc.split(";").map((item, key) => {
                            return (
                              <span key={key}>
                                {item}
                                <br />
                              </span>
                            );
                          })}
                      </span>
                    </div>
                  )}
                  {item.bcc && (
                    <div>
                      <strong>bcc: </strong>
                      <span>
                        {item.bcc &&
                          item.bcc.split(";").map((item, key) => {
                            return (
                              <span key={key}>
                                {item}
                                <br />
                              </span>
                            );
                          })}
                      </span>
                    </div>
                  )}
                </div>
                <div className="transport-status-content">
                  <div
                    className={
                      "transport-status-inner text-center report-status-" +
                      (item.state && item.state.toLowerCase())
                    }
                  >
                    {translate(item.state.toLowerCase())}
                  </div>
                </div>
              </div>
            </td>,
          ];
        });
    };

    const getSftpTransport = (transportItems) => {
      return transportItems
        .filter((item) => item.type === "Sftp" || item.type === "Ftp")
        .map((item, index) => {
          return [
            <td
              key={"header-ftp-" + index}
              className="additional-info-header"
              style={{ padding: "0" }}
            >
              <div>
                <span style={{ padding: "5px 0" }}>FTP/SFTP</span>
              </div>
            </td>,
            <td key={"ftp-" + index} className="additional-info-content">
              <div className="transport-content">
                <div>
                  <div>{translate("File/Files uploaded to")}:</div>
                  <div>
                    <strong>{translate("Server")}: </strong>
                    <span>{item.server}</span>
                  </div>
                  {item.directory && (
                    <div>
                      <strong>{translate("Folder")}: </strong>
                      <span>{item.directory}</span>
                    </div>
                  )}
                  {item.userName && (
                    <div>
                      <strong>{translate("Username")}: </strong>
                      <span>{item.userName}</span>
                    </div>
                  )}
                  <div>
                    <strong>{translate("Password")}: </strong>
                    <span>********</span>
                  </div>
                </div>
                <div className="transport-status-content">
                  <div
                    className={
                      "transport-status-inner text-center report-status-" +
                      (item.state && item.state.toLowerCase())
                    }
                  >
                    {translate(item.state.toLowerCase())}
                  </div>
                </div>
              </div>
            </td>,
          ];
        });
    };

    const getDatePeriodString = function (timeDiff) {
      if (!timeDiff) {
        return "";
      }
      var diffDays = Math.round(timeDiff / (1000 * 3600 * 24));
      var resultText = "";
      if (diffDays < 1) {
        var diffHours = Math.round(timeDiff / (1000 * 3600));
        if (diffHours >= 1) {
          resultText = plural(diffHours, "hour");
        } else {
          var diffMinutes = Math.round(timeDiff / (1000 * 60));
          if (diffMinutes) {
            resultText = plural(diffMinutes, "minute");
          } else {
            var diffSeconds = Math.round(timeDiff / 1000);
            if (diffSeconds) {
              resultText = plural(diffSeconds, "second");
            } else {
              resultText = "less than a second";
            }
          }
        }
      } else if (diffDays < 7) {
        resultText = plural(diffDays, "day");
      } else {
        var diffWeeks = Math.round(diffDays / 7);
        if (diffWeeks < 5) {
          resultText = plural(diffWeeks, "week");
        } else {
          var diffMonths = Math.round(diffDays / 30);
          resultText = plural(diffMonths, "month");
        }
      }
      return resultText;
    };

    const stagesList = ({ components: items, pipelineInstanceId: pipelineId, customerId }) => {
      let _resList = [];
      (items || []).forEach((item, index) => {
        if (item.type === "transport") {
          var smtpRows =
            item.additionalInfo &&
            item.additionalInfo.transportItems &&
            getSmtpTransport(item.additionalInfo.transportItems);

          if (smtpRows && smtpRows.length) {
            _resList.push(
              <tr key={index}>
                {smtpRows}
                <td
                  rowSpan={`${smtpRows && smtpRows.length}`}
                  className="text-center"
                >
                  {item.state && (
                    <div
                      style={{
                        textTransform: "uppercase",
                        display: "inline-block",
                      }}
                      className={"report-status-" + item.state.st}
                    >
                      {translate(item.state.st.toLowerCase())}
                    </div>
                  )}
                </td>
                {!isExternalUser && (
                  <td
                    rowSpan={`${smtpRows && smtpRows.length}`}
                    className="text-center"
                  >
                    {item.state.duration &&
                      getDatePeriodString(item.state.duration)}
                  </td>
                )}
                {!isExternalUser && (
                  <td
                    rowSpan={`${smtpRows && smtpRows.length}`}
                    className="text-center"
                    style={{
                      height: "36px",
                      fontWeight: "400",
                      fontSize: "1em",
                    }}
                    title="Restart Pipeline Component'"
                  >
                    <button
                      className="btn btn-secondary btn-sm btn-sm"
                      style={{ fontSize: "13px" }}
                      onClick={(e) => {
                        me.handleRestartPipelineComponentClick(
                          e,
                          pipelineId,
                          index
                        );
                      }}
                    >
                      <i className="fa fa-play" aria-hidden="true" />
                    </button>
                  </td>
                )}
              </tr>
            );
          }
          var ftpRows =
            item.additionalInfo &&
            item.additionalInfo.transportItems &&
            getSftpTransport(item.additionalInfo.transportItems);
          if (ftpRows && ftpRows.length) {
            _resList.push(
              <tr key={index}>
                {ftpRows}
                <td
                  rowSpan={`${ftpRows && ftpRows.length}`}
                  className="text-center"
                >
                  {item.state && (
                    <div
                      style={{
                        textTransform: "uppercase",
                        display: "inline-block",
                      }}
                      className={"report-status-" + item.state.st}
                    >
                      {translate(item.state.st.toLowerCase())}
                    </div>
                  )}
                </td>
                {!isExternalUser && (
                  <td
                    rowSpan={`${ftpRows && ftpRows.length}`}
                    className="text-center"
                  >
                    {item.state.duration &&
                      getDatePeriodString(item.state.duration)}
                  </td>
                )}
                {!isExternalUser && (
                  <td
                    rowSpan={`${ftpRows && ftpRows.length}`}
                    className="text-center"
                    style={{
                      height: "36px",
                      fontWeight: "400",
                      fontSize: "1em",
                    }}
                    title="Restart Pipeline Component'"
                  >
                    <button
                      className="btn btn-secondary btn-sm btn-sm"
                      style={{ fontSize: "13px" }}
                      onClick={(e) => {
                        me.handleRestartPipelineComponentClick(
                          e,
                          pipelineId,
                          index
                        );
                      }}
                    >
                      <i className="fa fa-play" aria-hidden="true" />
                    </button>
                  </td>
                )}
              </tr>
            );
          }
        } else {
          _resList.push(
            <tr key={index}>
              <td className="additional-info-header" style={{ padding: "0" }}>
                <div>
                  <span>{translate("Script")}</span>
                </div>
              </td>
              <td className="additional-info-content">
                {getAdditionalInfo(item.type, item.additionalInfo, pipelineId, customerId)}
              </td>
              <td className="text-center">
                {item.state && (
                  <div
                    style={{
                      textTransform: "uppercase",
                      display: "inline-block",
                    }}
                    className={"report-status-" + item.state.st}
                  >
                    {translate(item.state.st.toLowerCase())}
                  </div>
                )}
              </td>
              {!isExternalUser && (
                <td className="text-center">
                  {item.state.duration &&
                    getDatePeriodString(item.state.duration)}
                </td>
              )}
              {!isExternalUser && (
                <td className="text-center">
                  <button
                    className="btn btn-secondary btn-sm btn-sm"
                    title="Restart pipeline"
                    style={{ fontSize: "13px" }}
                    onClick={(e) => {
                      me.handleRestartPipelineComponentClick(
                        e,
                        pipelineId,
                        index
                      );
                    }}
                  >
                    <i className="fa fa-play" aria-hidden="true" />
                  </button>
                </td>
              )}
            </tr>
          );
        }
      });
      return _resList;
    };

    var _repDescJson = config.reportsDescriptions || [];
    executedReports.forEach((report, index) => {
      var _repDescObjRef =
        _repDescJson.find((obj) => {
          return obj.reporttemplatename === report.templateId;
        }) || {};
      table_html.push(
        <tr
          key={index}
          className={
            "row_tr finger w_p_action " +
            (report.mode === "test" ? " mode_color" : "") +
            (report.isActive ? " active-row" : "")
          }
          dataactionid={index}
          onClick={(e) => {
            me.handleRowClick(e, report, index);
          }}
        >
          {!isExternalUser && (
            <td
              data-action="multi-select-action"
              onClick={(e) => me.toggleRowMultiSelect(e, report, index)}
              className="text-center hidden-sm-screen"
            >
              <input
                type="checkbox"
                data-action="multi-select-action"
                name="check"
                checked={me.isFileSelected(report.pipelineInstanceId)}
                onClick={(e) => e.stopPropagation()}
                onChange={(e) => {
                  me.toggleRowMultiSelect(e, report, index);
                }}
              />
            </td>
          )}
          <td className="text-center">
            <span
              className="fa fa-angle-double-down"
              style={{ fontSize: "1.3em" }}
            />
          </td>
          {!isExternalUser && (
            <td style={{ maxWidth: "250px" }}>{report.customer}</td>
          )}
          <td style={{ padding: "0.25rem" }}>
            <div className="report-name-container">
              <div
                className="report-name-text"
                style={{ display: "flex", flexDirection: "column" }}
              >
                <div>
                  <b>{translate("Name")}:</b> {report.reportName}
                </div>
                <div>
                  <b>{translate("Report Type")}:</b>{" "}
                  {_repDescObjRef
                    ? _repDescObjRef.reportvisiblename || report.templateId
                    : report.templateId}
                </div>
              </div>
              {!(
                report.reportInitialData &&
                report.reportInitialData.triggerType === "downloadData"
              ) &&
                (!isExternalUser ||
                  (isExternalUser && !!_repDescObjRef.visibleForExternal)) && (
                  <Button
                    color="secondary"
                    className="float-aligned-right"
                    title="Edit configured report"
                    style={{ fontSize: "13px" }}
                    data-action="restart-pipeline"
                    onClick={(e) => {
                      me.handleEditConfigReportClick(e, report);
                    }}
                  >
                    <i
                      className="fa fa-edit"
                      data-action="restart-pipeline"
                      aria-hidden="true"
                    />
                  </Button>
                )}
            </div>
          </td>
          <td className="text-center">
            {report.reportInitialData &&
              report.reportInitialData.triggerType && [
                <span
                  key={"reportType-" + index}
                  className={
                    "fa fa-" +
                    (report.reportInitialData.triggerType === "recurringreport"
                      ? "clock"
                      : "bolt")
                  }
                  data-place="bottom"
                  data-tip={translate(
                    report.reportInitialData.triggerType === "recurringreport"
                      ? "Scheduler"
                      : "System event"
                  )}
                  style={{ color: "#495057", fontSize: "2em" }}
                />,
                <ReactTooltip key={"reportTypeTip-" + index} />,
              ]}
          </td>
          <td className="text-center">
            {report.startTs
              ? moment
                  .utc(report.startTs, moment.ISO_8601)
                  .format("DD-MM-YYYY HH:mm:ss")
              : "n/a"}
          </td>
          <td className="text-center">
            {report.reportStatus && (
              <div
                style={{ textTransform: "uppercase", display: "inline-block" }}
                className={"report-status-" + report.reportStatus.st}
              >
                {translate(report.reportStatus.st.toLowerCase())}
              </div>
            )}
          </td>
          <td className="text-center">
            {report.reportStatus &&
              getDatePeriodString(report.reportStatus.duration)}
          </td>
          {!isExternalUser && (
            <td className="text-center">
              <Button
                color="secondary"
                title="Restart as new pipeline"
                style={{ fontSize: "13px" }}
                data-action="restart-pipeline"
                onClick={(e) => {
                  me.handleRestartAsNewPipelineClick(e, report);
                }}
              >
                <span data-action="restart-pipeline">
                  <i className="fa fa-play" data-action="restart-pipeline" />
                  <i
                    style={{ marginLeft: "2px" }}
                    data-action="restart-pipeline"
                    className="fa fa-asterisk"
                  />
                </span>
              </Button>
              <Button
                color="secondary"
                title="Restart pipeline"
                style={{ fontSize: "13px", marginLeft: "10px" }}
                data-action="restart-pipeline"
                onClick={(e) => {
                  me.handleRestartPipelineClick(e, report);
                }}
              >
                <i
                  className="fa fa-play"
                  data-action="restart-pipeline"
                  aria-hidden="true"
                />
              </Button>
            </td>
          )}
        </tr>
      );
      table_html.push(
        <tr
          key={"sub_" + index}
          className="w_subtable_id"
          hidden={!report.expanded}
        >
          <td
            colSpan="100%"
            style={{
              backgroundColor: "#FAFAFA",
              borderBottomLeftRadius: "10px",
              borderBottomRightRadius: "10px",
            }}
          >
            <div
              className="row panel panel-default"
              style={{ marginLeft: "auto", marginRight: "auto", width: "80%" }}
            >
              <div className="sub-report-row-left panel panel-default">
                <table
                  className="table-bordered table-condensed table-hover table-sm panel-default col-lg-12 col-md-12 col-sm-12 col-xs-12 col-lg-offset-0"
                  cellSpacing="0"
                  style={{ border: "0px", padding: "10px" }}
                >
                  <thead className="grids_header">
                    <tr>
                      <th className="text-center">
                        {translate("Parameter name")}
                      </th>
                      <th className="text-center">{translate("Value")}</th>
                    </tr>
                  </thead>
                  <tbody>
                    {paramsList(_repDescObjRef.viewModeParameters, index)}
                  </tbody>
                </table>
                {!isExternalUser && (
                  <div className="row col-lg-6 col-md-8 col-sm-12 col-xs-12 mx-auto justify-content-center">
                    <button
                      onClick={(e) => {
                        this.handleOpenFullEventClick(
                          e,
                          execReportsPipelines[index]
                        );
                      }}
                      style={{
                        color: "#000",
                        border: "none",
                        margin: "0px 0px 10px 10px",
                      }}
                      className="default-button-link"
                    >
                      {translate("View All")}
                    </button>
                  </div>
                )}
              </div>
              <div className="sub-report-row-main panel panel-default">
                <table
                  className="table-bordered table-condensed table-hover table-sm panel-default col-lg-12 col-md-12 col-sm-12 col-xs-12 col-lg-offset-0"
                  cellSpacing="0"
                  style={{ border: "0px", padding: "10px" }}
                >
                  <colgroup>
                    <col width="27" />
                    <col width="1*" />
                    <col width="140" />
                    <col width="100" />
                    <col width="100" />
                  </colgroup>
                  <thead className="grids_header">
                    <tr>
                      <th colSpan="2" className="text-center">
                        {translate("Additional info")}
                      </th>
                      <th className="text-center">{translate("Status")}</th>
                      {!isExternalUser && (
                        <th className="text-center">{translate("Duration")}</th>
                      )}
                      {!isExternalUser && (
                        <th className="text-center">{translate("Actions")}</th>
                      )}
                    </tr>
                  </thead>
                  <tbody>
                    {stagesList(report)}
                  </tbody>
                </table>
              </div>
            </div>
          </td>
        </tr>
      );
    });

    return (
      <div className="col-12" style={{ padding: "0px" }}>
        <div className="row" style={{ margin: "0px" }}>
          <table
            className="table-bordered table-condensed cf table-hover table-sm panel-default col-12 col-lg-offset-0"
            cellSpacing="0"
            style={{ border: "0px", padding: "0px" }}
          >
            <thead
              style={{ background: "#3A4A57", color: "#fff" }}
              className="grids_header"
            >
              <tr style={{ fontSize: ".8rem" }}>
                {!isExternalUser && (
                  <th className="text-center">
                    <input
                      type="checkbox"
                      name="check-all"
                      checked={me.isAllSelected()}
                      onChange={(e) => {
                        me.toggleMultiSelectAll(e);
                      }}
                    />
                  </th>
                )}
                <th className="text-center" />
                {!isExternalUser && <th>{translate("Customer")}</th>}
                <th className="text-center">{translate("Report name")}</th>
                <th className="text-center">{translate("Trigger")}</th>
                <th className="text-center">{translate("TimeStamp")}</th>
                <th className="text-center">{translate("Status")}</th>
                <th className="text-center">{translate("Duration")}</th>
                {!isExternalUser && <th className="text-center">Actions</th>}
              </tr>
            </thead>
            <tbody style={{ backgroundColor: "#fff", fontSize: "12px" }}>
              {table_html}
            </tbody>
          </table>
        </div>
      </div>
    );
  };

  handleSearchClick = (event) => {
    if (event) event.preventDefault();
    const { dispatch, execReportSearch, isExternalUser, externalCustomerId } =
      this.props;
    dispatch(actions.change("execReportSearch.PageNumber", 1));
    dispatch(
      reportActions.getExecutedReports(
        getSearchingData(
          { ...execReportSearch, PageNumber: 1 },
          isExternalUser,
          externalCustomerId
        )
      )
    ).then((data) => {
      if (data.reports && data.reports.length === 0) {
        dispatch(actions.change(`execReportSearch.showMoreHeight`, "auto"));
        dispatch(
          actions.change(`execReportSearch.moreArrowIcon`, "fa-chevron-up")
        );
        dispatch(
          actions.change(
            `execReportSearch.toggleBtnTitle`,
            "Hide advanced search options"
          )
        );
      }
    });
    if (execReportSearch.SearchText) {
      let _searchQry = this.props.location.search;
      let _pushHistory = false;
      if (!_searchQry) {
        _pushHistory = true;
      } else {
        let queryObj = qs.parse(_searchQry.substr(1));
        if (queryObj["search"] !== execReportSearch.SearchText) {
          _pushHistory = true;
        }
      }
      if (_pushHistory) {
        var qData = {
          search: execReportSearch.SearchText,
        };
          //next line is temporary commented by P.L. to prevent double search execution
          //this.props.history.push("/exec-reports?" + qs.stringify(qData));
          //TODO: some kind of fix should be applied to handle query string changes poroperly
      }
    } else {
      let _searchQry = this.props.location.search;
      if (_searchQry) {
        this.props.history.push("/exec-reports");
      }
    }
  };

  handleParamChange = (paramName, paramValue) => {
    this.props.dispatch(
      actions.change(`execReportSearch.${paramName}`, paramValue)
    );
  };

  handlePageReload = () => {
    const { dispatch, execReportSearch, isExternalUser, externalCustomerId } =
      this.props;
    var _pageNum = execReportSearch.PageNumber;
    if (_pageNum > 0) {
      dispatch(actions.change("execReportSearch.PageNumber", _pageNum));
      dispatch(
        reportActions.getExecutedReports(
          getSearchingData(
            {
              ...execReportSearch,
              PageNumber: _pageNum,
            },
            isExternalUser,
            externalCustomerId
          )
        )
      );
    }
  };

  handleRestartAsNewPipelineClick = (e, report) => {
    e.preventDefault();
    var me = this,
      params = {
        PipelineId: report.pipelineInstanceId,
        EnableTransport: true,
      };
    me.props.dispatch(loaderMaskActions.show("Restarting as new pipeline..."));
    axios
      .post("Reporting/Pipelines/RestartAsNewInstance", params)
      .then((response) => {
        if (response.data.Errors && response.data.Errors.length) {
          me.props.dispatch(loaderMaskActions.hide(""));
          me.setState({
            msg: {
              header: "Restart as New Pipeline",
              message: (
                <Alert style={{ width: "650px" }} color="danger">
                  Restart as New Pipeline action failed.
                </Alert>
              ),
            },
          });
        } else {
          me.setState({
            msg: {
              header: "Restart as New Pipeline",
              message: (
                <Alert style={{ width: "650px" }} color="success">
                  Restart as New Pipeline action succeed.
                </Alert>
              ),
            },
          });
          // reload search
          if (me.props.reports.executedReports) {
            me.handlePageReload();
          } else {
            me.props.dispatch(loaderMaskActions.hide(""));
          }
        }
      });
  };

  handleRestartPipelineClick = (e, report) => {
    e.preventDefault();
    var me = this,
      params = {
        PipelineId: report.pipelineInstanceId,
        EnableTransport: true,
      };
    me.props.dispatch(loaderMaskActions.show("Restarting pipeline..."));
    axios
      .post("Reporting/Pipelines/Restart", {}, { params })
      .then((response) => {
        if (response.data.Errors && response.data.Errors.length) {
          me.props.dispatch(loaderMaskActions.hide(""));
          me.setState({
            msg: {
              header: "Restart Pipeline",
              message: (
                <Alert style={{ width: "650px" }} color="danger">
                  Restart Pipeline action failed.
                </Alert>
              ),
            },
          });
        } else {
          me.setState({
            msg: {
              header: "Restart Pipeline",
              message: (
                <Alert style={{ width: "650px" }} color="success">
                  Restart Pipeline action succeed.
                </Alert>
              ),
            },
          });
          // reload search
          if (me.props.reports.executedReports) {
            me.handlePageReload();
          } else {
            me.props.dispatch(loaderMaskActions.hide(""));
          }
        }
      });
  };

  handleRestartPipelineComponentClick = (e, pipelineId, index) => {
    e.preventDefault();
    var me = this,
      params = {
        PipelineId: pipelineId,
        ComponentIndex: index,
      };
    me.props.dispatch(
      loaderMaskActions.show("Restarting pipeline component...")
    );
    axios
      .post("Reporting/Pipelines/RestartComponent", {}, { params })
      .then((response) => {
        if (response.data.Errors && response.data.Errors.length) {
          me.props.dispatch(loaderMaskActions.hide(""));
          me.setState({
            msg: {
              header: "Restart Pipeline Component",
              message: (
                <Alert style={{ width: "650px" }} color="danger">
                  Restart Pipeline Component action failed.
                </Alert>
              ),
            },
          });
        } else {
          me.setState({
            msg: {
              header: "Restart Pipeline Component",
              message: (
                <Alert style={{ width: "650px" }} color="success">
                  Restart Pipeline Component action succeed.
                </Alert>
              ),
            },
          });
          // reload search
          if (me.props.reports.executedReports) {
            me.handlePageReload();
          } else {
            me.props.dispatch(loaderMaskActions.hide(""));
          }
        }
      });
  };

  toggleMsgBox = () => {
    this.setState({
      msg: {},
      pastNextLaunchConfirmModal: false,
      reportDataToBeSaved: null,
      resetLoader: null,
    });
  };

  componentDidMount() {
    const {
      dispatch,
      reports,
      loaderMask,
      defaultSize,
      isExternalUser,
      externalCustomerId,
    } = this.props;
    let _searchQry = this.props.location.search;
    if (
      _searchQry &&
      !reports.cleared &&
      !reports.error &&
      !reports.loading &&
      !reports.execReportsFromURIQuery &&
      !loaderMask.show
    ) {
      let queryObj = qs.parse(_searchQry.substr(1));
      if (queryObj["config_report_id"]) {
        let params = {
          PageNumber: 1,
          Size: defaultSize || 20,
          reportDefinitionId: queryObj["config_report_id"],
        };
        // Force setting customerId for subuser if present in the url
        if (isExternalUser) {
          params["CustomerId"] = externalCustomerId;
        }
        if (queryObj["CustomerId"]) {
          params["CustomerId"] = queryObj["CustomerId"];
          if (
            !isExternalUser ||
            queryObj["CustomerId"] !== externalCustomerId
          ) {
            dispatch(
              actions.change(
                "execReportSearch.CustomerId",
                queryObj["CustomerId"]
              )
            );
          }
        }
        dispatch(reportActions.getExecReportsFromURIQuery(params));
      } else if (queryObj.search) {
        const {
          dispatch,
          execReportSearch,
          isExternalUser,
          externalCustomerId,
        } = this.props;
        this.handleParamChange("SearchText", queryObj.search);
        this.handleParamChange("PageNumber", 1);
        dispatch(
          reportActions.getExecutedReports(
            getSearchingData(
              {
                ...execReportSearch,
                SearchText: queryObj.search,
                PageNumber: 1,
              },
              isExternalUser,
              externalCustomerId
            )
          )
        );
      }
    }
  }

  render() {
    const { reports, execReportSearch, translate } = this.props;

    let PageNumber = reports.execReportsFromURIQuery
      ? reports.execReportsParams.PageNumber
      : execReportSearch.PageNumber;

    let Size = reports.execReportsFromURIQuery
      ? reports.execReportsParams.Size
      : execReportSearch.Size;

    let prev = PageNumber > 0 ? PageNumber - 1 : 0;
    let pageNumbers = [];
    // get window of max 5
    let start = PageNumber;
    let last = start + 5;
    if (last > reports.ERTotalPages) {
      last = reports.ERTotalPages;
    }
    for (let i = start; i <= last; i++) {
      pageNumbers.push(i);
    }
    const startRecordCount = (PageNumber - 1) * Size + 1;
    const endRecordCount = startRecordCount + reports.ERCount - 1;

    return (
      <>
        <div className="w-100 top_search" style={{ textAlign: "center" }}>
          <SearchPanel
            view="execReportsView"
            searchParams={execReportSearch}
            isExternalUser={this.props.isExternalUser}
            handleParamChange={this.handleParamChange}
            onSearchClick={(params_) => {
              this.handleSearchClick(params_);
            }}
          />
        </div>
        <div
          className="content_block fill col-lg-12 col-md-12 col-sm-12 col-xs-12"
          style={{ padding: "0", width: "100%" }}
        >
          {reports.executedReports && this.generateReportGrid()}
          {reports.executedReports && reports.executedReports.length > 0 && (
            <div className="grid-footer">
              <FormGroup className="mb-2 mr-sm-2 mb-sm-0 form-inline paging-count-select">
                <Label htmlFor="exReportSizeSelect">Rows count</Label>
                <Input
                  type="select"
                  name="exReportSize"
                  id="exReportSizeSelect"
                  value={Size}
                  onChange={this.handlePageSizeChange}
                >
                  <option>10</option>
                  <option>20</option>
                  <option>40</option>
                  <option>50</option>
                  <option>100</option>
                </Input>
              </FormGroup>
              <Pagination className="mt-2 text-center">
                <PaginationItem>
                  {prev === 0 ? (
                    <PaginationLink disabled>
                      <small>
                        <span className="fa fa-fast-backward" />
                      </small>
                      &nbsp;{translate("First")}
                    </PaginationLink>
                  ) : (
                    <PaginationLink
                      onClick={this.handleFirstClick}
                      id={prev}
                      href={prev}
                    >
                      <small>
                        <span className="fa fa-fast-backward" />
                      </small>
                      &nbsp;{translate("First")}
                    </PaginationLink>
                  )}
                </PaginationItem>
                <PaginationItem>
                  {prev === 0 ? (
                    <PaginationLink disabled>
                      <small>
                        <span className="fa fa-backward" />
                      </small>
                      &nbsp;{translate("Prev")}
                    </PaginationLink>
                  ) : (
                    <PaginationLink
                      onClick={this.handlePageClick}
                      id={prev}
                      href={prev}
                    >
                      <small>
                        <span className="fa fa-backward" />
                      </small>
                      &nbsp;{translate("Prev")}
                    </PaginationLink>
                  )}
                </PaginationItem>
                {pageNumbers.map((number, i) => (
                  <Pagination key={i}>
                    <PaginationItem
                      active={
                        pageNumbers.indexOf(PageNumber) === i ? true : false
                      }
                    >
                      <PaginationLink
                        onClick={this.handlePageClick}
                        href={number}
                        key={number}
                        id={number}
                      >
                        {number}
                      </PaginationLink>
                    </PaginationItem>
                  </Pagination>
                ))}

                <PaginationItem>
                  {PageNumber >= last ? (
                    <PaginationLink disabled>
                      {translate("Next")}&nbsp;
                      <small>
                        <span className="fa fa-forward" />
                      </small>
                    </PaginationLink>
                  ) : (
                    <PaginationLink
                      onClick={this.handlePageClick}
                      id={pageNumbers[pageNumbers.indexOf(PageNumber) + 1]}
                      href={pageNumbers[pageNumbers.indexOf(PageNumber) + 1]}
                    >
                      {translate("Next")}&nbsp;
                      <small>
                        <span className="fa fa-forward" />
                      </small>
                    </PaginationLink>
                  )}
                </PaginationItem>
              </Pagination>
              <div className="grid-paging-info">
                Displaying {startRecordCount} to {endRecordCount}
              </div>
            </div>
          )}
        </div>
        <Modal
          className="model-custom-width"
          style={{ width: "70vw", maxWidth: "95vw" }}
          isOpen={this.state.fullEventModal}
          toggle={this.toggleFullEventModal}
        >
          <ModalHeader toggle={this.toggleFullEventModal}>
            {translate("Details")}
          </ModalHeader>
          <ModalBody>
            <ReactJson
              src={this.state.eventJsonObj}
              enableClipboard
              displayDataTypes={false}
            />
          </ModalBody>
        </Modal>
        <Modal
          isOpen={!!this.state.msg.message}
          style={{ maxWidth: "700px", maxHeight: "700px" }}
          toggle={this.toggleMsgBox}
        >
          {this.state.msg.header && (
            <ModalHeader toggle={this.toggleMsgBox}>
              {this.state.msg.header}
            </ModalHeader>
          )}
          <ModalBody>{this.state.msg.message}</ModalBody>
          <ModalFooter className="text-center">
            <Button
              color="primary"
              className="switchBtn"
              style={{ width: "100px" }}
              onClick={this.toggleMsgBox}
            >
              {translate("OK")}
            </Button>
          </ModalFooter>
        </Modal>
        <Modal
          isOpen={this.state.pastNextLaunchConfirmModal}
          toggle={this.togglePastNextLaunchConfirmModal}
        >
          <ModalHeader toggle={this.togglePastNextLaunchConfirmModal}>
            {translate("ScheduleNextLaunchWarning")}
          </ModalHeader>
          <ModalBody>
            <Alert color="warning">
              You choose a date in a past for scheduled reports. That will
              launch a generation and delivery of all the reports from the day
              you specified till current day.
              <br />
              This could lead to spamming recipients of e-mails and uploading a
              lot of files to SFTP/FTP connections.
              <br />
              Do you really want to set the date in the past?
            </Alert>
          </ModalBody>
          <ModalFooter className="text-center">
            <Button
              color="secondary"
              style={{ width: "90px" }}
              onClick={this.handleYesConfirmNextLaunchDialog}
            >
              {translate("Yes")}
            </Button>
            <Button
              color="primary"
              className="EventSearchSubmit"
              style={{ marginLeft: "60px", width: "90px" }}
              onClick={this.handleNoConfirmNextLaunchDialog}
            >
              {translate("No")}
            </Button>
          </ModalFooter>
        </Modal>
        <Modal isOpen={this.state.loadingFile}>
          <ModalBody>
            <Spinner color="warning" /> {translate("Downloading")}...
          </ModalBody>
        </Modal>
        <EditConfigReport
          reportDefinitionId={this.state.selectedReport._id}
          reportPipelineDefinitionId={
            this.state.selectedReport.reportPipelineDefinitionId
          }
          handleFormSave={this.handleFormSave}
          handleActiveChange={this.handleActiveChange}
          isActive={this.state.editReportIsActive}
          isExternalUser={this.props.isExternalUser}
          handleInternalUseChange={this.handleInternalUseChange}
          internalUse={this.state.editReportIsInternalUse}
        />
      </>
    );
  }
}

function getSearchingData(params, isExternalUser, externalCustomerId) {
  var paramsObj = {
    IsPlatformSpecific: false,
  };
  if (params.SearchText && params.SearchText.toString().trim().length) {
    paramsObj["SearchText"] = params.SearchText;
  }
  if (isExternalUser) {
    if (params.CustomerId) {
      paramsObj["CustomerId"] = params.CustomerId;
    } else {
      paramsObj["CustomerId"] = externalCustomerId;
    }
  } else {
    if (params.CustomerId) {
      paramsObj["CustomerId"] = params.CustomerId;
    }
  }
  if (params.ProjectId) {
    paramsObj["ProjectId"] = params.ProjectId;
  }
  if (params.ReportState) {
    paramsObj["ReportState"] = params.ReportState;
  }
  if (params.TemplateId) {
    paramsObj["TemplateId"] = params.TemplateId;
  }
  if (params.HasDocuments) {
    paramsObj["HasDocuments"] = params.HasDocuments;
  }
  if (params.Start) {
    paramsObj["Start"] = moment
      .utc(params.Start)
      .format("YYYY-MM-DDTHH:mm:ss.SSS");
  }
  if (params.End) {
    paramsObj["End"] = moment.utc(params.End).format("YYYY-MM-DDTHH:mm:ss.SSS");
  }
  paramsObj["PageNumber"] = params.PageNumber;
  paramsObj["Size"] = params.Size;

  return paramsObj;
}

function plural(v, s, p) {
  return v + " " + (v === 1 ? s : p ? p : s + "s");
}

function mapStateToProps(state) {
  const { config, reports, execReportSearch, locale, loaderMask } = state;
  return {
    config,
    reports,
    execReportSearch,
    loaderMask,
    translate: getTranslate(locale),
  };
}

const connectedExecReports = connect(mapStateToProps)(withRouter(ExecReports));
export { connectedExecReports as ExecReports };
